export const NP_DOCUMENT_TITLE_TAG = '<np-document-title/>';
const DOCUMENT_TITLE_TAG_LINE_REGEX = /^<np-document-title\b[^>]*\/>\s*$/gm;

function escapeHtmlAttribute(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function createDocumentTitleTag(explicitTitle?: string | null): string {
  const normalizedTitle = explicitTitle?.trim() ?? '';
  if (!normalizedTitle) {
    return NP_DOCUMENT_TITLE_TAG;
  }

  return `<np-document-title data-title="${escapeHtmlAttribute(normalizedTitle)}"/>`;
}

export function countDocumentTitleTags(value: string): number {
  const matches = value
    .replace(/\r\n/g, '\n')
    .match(DOCUMENT_TITLE_TAG_LINE_REGEX);
  return matches?.length ?? 0;
}

export function createDefaultMarkdownDocumentValue(): string {
  return `${createDocumentTitleTag()}\n\n`;
}

export function prependDocumentTitleTag(value: string): string {
  const normalized = value.replace(/\r\n/g, '\n').trim();
  if (countDocumentTitleTags(normalized) > 0) {
    return normalized.length > 0 ? `${normalized}\n` : normalized;
  }

  return normalized.length > 0
    ? `${createDocumentTitleTag()}\n\n${normalized}\n`
    : createDefaultMarkdownDocumentValue();
}

export function getDocumentTitleTagValidationMessage(
  value: string,
): string | null {
  const count = countDocumentTitleTags(value);
  if (count <= 1) return null;

  return 'Only one <np-document-title/> block is supported per markdown document.';
}
